







































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Flipbook from 'flipbook-vue'
import { PictureBookController } from '@/services/request.service'

@Component({
  components: {
    Flipbook,
  },
})
export default class Book extends Vue {
  private flipbook: any = {}
  private bookId = 0
  private pages: Array<any> = []
  private audios: Array<any> = []
  private pageNumList: Array<any> = []
  private currentPage = 1
  private fliping = false
  private imageLoading = false
  private loadImageProcess = 0
  private audio: any = null
  private audioUrl = ''
  private playing = ''

  private created(): void {
    this.bookId = parseInt(this.$route.params.bookId, 10)
    this.imageLoading = true
    this.getBook()
  }

  private beforeDestroy(): void {
    if (this.audio) {
      this.audio.pause()
    }
  }

  private get devicePixelRatio(): number {
    const agent = navigator.userAgent.toLowerCase()
    if (agent.indexOf('windows') >= 0) {
      return window.devicePixelRatio
    } else {
      return 1
    }
  }

  private getBook(): void {
    PictureBookController.getPictureBook(this.bookId)
      .then(res => {
        const covers = res.data.pictureBookPageUrl[1801].map(page => page.pageUrl)
        const coverAudios = res.data.pictureBookPageUrl[1801].map(page => {
          return {
            en: page.audioEN,
            zh: page.audioCN,
          }
        })
        const abouts = res.data.pictureBookPageUrl[1802].map(page => page.pageUrl)
        const aboutAudios = res.data.pictureBookPageUrl[1802].map(page => {
          return {
            en: page.audioEN,
            zh: page.audioCN,
          }
        })
        const pages = res.data.pictureBookPageUrl[1803].map(page => page.pageUrl)
        const pageAudios = res.data.pictureBookPageUrl[1803].map(page => {
          return {
            en: page.audioEN,
            zh: page.audioCN,
          }
        })
        let newPages = [...covers, ...abouts, ...pages]
        let newAudios = [...coverAudios, ...aboutAudios, ...pageAudios]
        this.loadImages(newPages, () => {
          this.imageLoading = false
        })
        this.pages = newPages
        this.audios = newAudios
        let list = [] as any
        pages.forEach((page, index) => {
          if (index % 2 === 0) {
            list.push({
              name: index + 2 + '-' + (index + 3),
              page: index + 5,
            })
          }
        })
        this.pageNumList = list
      })
      .catch(err => {
        console.warn(err)
      })
  }

  private loadImages(sources, callback): void {
    let count = 0
    let images = [] as any
    let imageNum = sources.length
    for (let i in sources) {
      if (sources[i]) {
        images[i] = new Image()
        images[i].onload = () => {
          count++
          this.loadImageProcess = Math.floor((count / imageNum) * 100)
          if (count >= imageNum) {
            callback(images)
          }
        }
        images[i].src = sources[i]
      }
    }
  }

  private flipTo(page): void {
    if (this.audio) {
      this.audio.pause()
    }
    if (!this.fliping) {
      const flipBook = this.$refs.flipBook as any
      const currentPage = flipBook.page
      const totalPages = flipBook.numPages
      this.fliping = true
      if (page < totalPages) {
        let delta = (page - currentPage) / 2
        if (delta > 0) {
          const interval = setInterval(() => {
            if (delta > 0) {
              flipBook.flipRight()
              delta = delta - 1
            } else {
              clearInterval(interval)
              this.fliping = false
            }
          }, 500)
        } else {
          const interval = setInterval(() => {
            if (delta < 0) {
              flipBook.flipLeft()
              delta = delta + 1
            } else {
              clearInterval(interval)
              this.fliping = false
            }
          }, 500)
        }
      }
      this.currentPage = page
    }
  }

  private flip(page): void {
    if (this.audio) {
      this.audio.pause()
      this.audioUrl = ''
      this.audio = null
      this.playing = ''
    }
    if (!this.fliping) {
      this.currentPage = page
      if (page === 1) {
        this.$message.warn(this.$tc('mibp.firstPage'))
      }
      if (page === this.pages.length - 1) {
        this.$message.warn(this.$tc('mibp.lastPage'))
      }
    }
  }

  private playAudioLeft(locale): void {
    this.playing = locale + 'Left'
    const { currentPage, audios } = this
    const url = audios[currentPage - 1][locale]
    if (this.audio) {
      this.audio.pause()
    }
    if (this.audioUrl === url) {
      this.audioUrl = ''
      this.audio = null
      this.playing = ''
    } else {
      this.audioUrl = url
      this.audio = new Audio(url)
      this.audio.play()
      this.audio.addEventListener('ended', () => {
        this.audioUrl = ''
        this.audio = null
        this.playing = ''
      })
    }
  }

  private playAudioRight(locale): void {
    this.playing = locale + 'Right'
    const { currentPage, audios } = this
    const url = audios[currentPage][locale]
    if (this.audio) {
      this.audio.pause()
    }
    if (this.audioUrl === url) {
      this.audioUrl = ''
      this.audio = null
      this.playing = ''
    } else {
      this.audioUrl = url
      this.audio = new Audio(url)
      this.audio.play()
      this.audio.addEventListener('ended', () => {
        this.audioUrl = ''
        this.audio = null
        this.playing = ''
      })
    }
  }

  private back(): void {
    this.$router.back()
  }
}
